// src/backendServices/mediaManagment/api_category.ts


import   axios                       from 'axios';

import { API_URLS                 }  from '../urls';

import { BackendResponse ,
         handleError              ,
         DUPLICATE_NAME_CODE      ,
         isDuplicateNameRefusal   ,
         extractApiErrorDetail    }  from '../../dataTypes/backendServicesManagment/types'

import { MediaCategory            ,
         initializedMediaCategory }  from '../../dataTypes/mediaManagment/types'

export interface BackendResponse_MediaCategory extends BackendResponse<MediaCategory []> {}


export const getMediaCategories = async (adminId?: number): Promise<BackendResponse_MediaCategory> => {

  const url         = API_URLS.getMediaCategories;
  const queryParams = new URLSearchParams();
  if (adminId) queryParams.append('adminId', adminId.toString());
  const queryString = queryParams.toString();
  const fullUrl      = queryString ? `${url}?${queryString}` : url;

  try
   {
    const response = await axios.get(fullUrl);

    if (response.status === 200)
	      {
           const categories: MediaCategory[] = response.data['hydra:member'].filter((category: any) => category.visible !== false).map((category: any) => {

             const defaultCategory = initializedMediaCategory();

             return {
                ...defaultCategory,
                id          : category.id          ?? defaultCategory.id          ,
                name        : category.name        ?? defaultCategory.name        ,
                rank        : category.rank        ?? defaultCategory.rank        ,
                visible     : category.visible     ?? defaultCategory.visible     ,
                mediaType   : category.mediaType   ?? defaultCategory.mediaType   ,
             };
           });

           console.log ('getMediaCategories', url, response, categories)

           return {
             code    : 1,
             comment : "The retrieval of video categories is complete.",
             payload : categories
           };
          }
	 else {
           return handleError<MediaCategory []>(response.status, "Non-200 response from API");
          }
   }
  catch (error)
   {
    if (axios.isAxiosError(error))
	 {
      return handleError<MediaCategory []>(-101, error.response?.data?.detail ?? error.message);
     }

    return handleError<MediaCategory []>(-102, "Unknown error");
   }
};

export const createMediaCategory = async ( name        : string  ,
                                           rank        : number  ,
                                           visible     : boolean ,
                                           mediaType   : string  ,
                                           adminId?    : number  ): Promise<BackendResponse<MediaCategory>> => {
  const url = API_URLS.createMediaCategory;

  const rankStr:    string = `${rank}`;
  const visibleStr: string = visible ? 'true' : 'false';

  const headers    = {
        'Accept': 'application/ld+json',
        'Content-Type': 'application/merge-patch+json'
        };

  try {
    const response = await axios.post(url, { name, rankStr, visibleStr , mediaType, ...(adminId ? { adminId } : {}) }, { headers });

    if (response.status === 201) {
      const defaultCategory = initializedMediaCategory();
      const created: MediaCategory = {
        ...defaultCategory,
        id        : response.data?.id        ?? defaultCategory.id        ,
        name      : response.data?.name      ?? defaultCategory.name      ,
        rank      : response.data?.rank      ?? defaultCategory.rank      ,
        visible   : response.data?.visible   ?? defaultCategory.visible   ,
        mediaType : response.data?.mediaType ?? defaultCategory.mediaType ,
      };
      return {
        code: 1,
        comment: "A new media category has been successfully created.",
        payload : created
      };
    } else {
      return handleError<MediaCategory>(response.status, "Non-201 response from API");
    }
  } catch (error) {

    if (axios.isAxiosError(error)) {
      const detail = extractApiErrorDetail(error.response?.data, error.message);

      // Un nom déjà pris n'est pas une panne : l'écran a de quoi le dire à
      // l'utilisateur, à condition de pouvoir le distinguer du reste.
      if (isDuplicateNameRefusal(error.response?.status, detail)) {
        return handleError<MediaCategory>(DUPLICATE_NAME_CODE, detail);
      }

      return handleError<MediaCategory>(-101, detail);
    }
    return handleError<MediaCategory>(-102, "Unknown error");
  }
};

export const patchMediaCategory = async ( id          : number  ,
                                          name        : string  ,
                                          rank        : number  ,
                                          visible     : boolean ,
                                          mediaType   : string  ,
                                          adminId?    : number  ): Promise<BackendResponse> => {

  const baseUrl = `${API_URLS.patchMediaCategory}`;
  const url = baseUrl.replace("{id}", `${id}`);

  const headers = {
    'Accept': 'application/ld+json',
    'Content-Type': 'application/merge-patch+json'
  };

  try
   {

	console.log ('handleMediaTypeChange', url, name, rank, visible , mediaType)
    const response = await axios.patch(url, { name, rank, visible , mediaType, ...(adminId ? { adminId } : {}) }, { headers });
	console.log ('handleMediaTypeChange', response)  

    if (response.status === 200)
          {
           return {
                    code    : 1,
                    comment : `The update of product category ${id} is complete.`,
                    payload : {} as any
                  };
          }
     else {
           return handleError<void>(response.status, "Non-200 response from API");
          }
   }
  catch (error)
   {
    if (axios.isAxiosError(error))
     {
      const detail = extractApiErrorDetail(error.response?.data, error.message);

      // Même refus qu'à la création, autre porte : renommer vers un nom déjà pris.
      if (isDuplicateNameRefusal(error.response?.status, detail))
       {
        return handleError<void>(DUPLICATE_NAME_CODE, detail);
       }

      return handleError<void>(-101, detail);
     }

    return handleError<void>(-102, "Unknown error");
   }
};

export const deleteMediaCategory = async (id: number, adminId?: number): Promise<BackendResponse> => {

  const baseUrl      = `${API_URLS.deleteMediaCategory}`;
  const queryParams  = new URLSearchParams();
  if (adminId) queryParams.append('adminId', adminId.toString());
  const queryString  = queryParams.toString();
  const url          = baseUrl.replace("{id}", `${id}`) + (queryString ? `?${queryString}` : '');

  const headers = {
    'Accept': 'application/ld+json'
  };

  try
   {
    const response = await axios.delete(url, { headers });

    if (response.status === 204)
          {
           return {
                    code    : 1,
                    comment : `The deletion of product category ${id} is complete.`,
                    payload : {} as any
                  };
          }
     else {
           return handleError<void>(response.status, "Non-204 response from API");
          }
   }
  catch (error)
   {
    if (axios.isAxiosError(error))
     {
      return handleError<void>(-101, error.response?.data?.detail ?? error.message);
     }

    return handleError<void>(-102, "Unknown error");
   }
};

